import { IGuarantor } from 'src/interfaces/mortgage-deal/invite-guarantor';
import { IDocument } from '../accounts/account';
import { IMortgageSupportingDoc } from './supporting-document';

export enum LoanProposalBiddingStatus {
	EmptyStatus = -2,
	FunderInitializeCounter = -1,
	FunderInvestPlannedProposal = 1,
	AdminRejectProposal = 2,
	AdminApprovedProposal = 3,

	WaitingForFunderAcceptAdminPropose = 4,
	FunderRejectAdminPropose = 5,
	FunderAcceptAdminPropose = 6,

	BorrowerChoseProposal = 7,
	BorrowerRejectProposal = 8,

	FunderSubmitCounterProposal = 9
}

export enum LOAN_PROPOSAL_TYPE {
	PlanedLoan = 1,
	FunderCounter = 2,
	AdminProvideProposalToFunder = 3,

	ClientNewCounterAddingType = -1
}

export enum BORROWER_GUARANTOR_TYPE {
	BORROWER = 1,
	GUARANTOR = 2
}

export interface ILoanDetails {
	borrowAmount?: string;
	borrowCurrency?: string;
	interestPaymentPeriod?: number;
	loanTerm?: number;
	proposedCurrency?: number[];
	useOfFunds?: string;
	useOfFundOther?: string;
}

export interface ISecurityDetails {
	propertyType?: string;
	noOfBedroom?: number;
	status?: string;
	condition?: string;
	addressLine?: string;
	street?: string;
	country?: string;
	district?: string;
	districtName?: string;
	zipCode?: string;
	purchaseCurrency?: string;
	purchasePrice?: string;
	currentOrExpectedCurrency?: string;
	currentOrExpectedRentPerMonth?: string;
	groundRentPerMonthCurrency?: string;
	groundRentPerMonth?: string;
	buildingManagementFeePerMonthCurrency?: string;
	buildingManagementFeePerMonth?: string;
	holdingType?: string;
	unexpiredTermOfLease?: number;
	ownership?: string;
	ownershipOther?: string;
	mortgageApprovedBySecondBankQuestion?: boolean;
	isSecondMortgageForSecurityQuestion?: boolean;

	isSecondMortgageForSecurityQuestionNote?: string;
	mortgageApprovedBySecondBankQuestionNote?: string;
}

export interface ISolicitorDetails {
	companyName?: string;
	addressLine?: string;
	street?: string;
	country?: string;
	district?: string;
	zipCode?: string;
	contactPerson?: string;
	contactCountryCode?: string;
	contactPhoneNumber?: string;
	emailAddress?: string;
}

export interface ILoanProposal {
	id?: string;
	mortgagePropertyDetailId?: string;
	type: LOAN_PROPOSAL_TYPE;
	interest?: number;
	interestCurrency?: string;
	interestPaymentPeriod?: number;
	loanPeriod?: number | string;
	loanRate?: number;
	ltv?: number | string;
	proposalLoanAmount?: number;
	proposalLoanAmountCurrency?: string;
	planOrder?: number;

}

export interface IMortgageDealMedia {
	coverPhoto: IDocument[];
	galleryPhoto: IDocument[];
}

export interface IPropertyDetailAddress {
	district: string;
	zipCode: string;
	country: string;
	addressLine: string;
	street: string;
}

export interface ISecuredPropertyDetail {
	mortgagePropertyDetailId: string;
	conditions: string;
	groundRent: number;
	groundRentCurrency: string;
	numberOfBathroom: number;
	numberOfBedroom: number;
	ownershipType: string;
	propertyType: string;
	remainingLeaseTerm: number;
	rentalIncome: number;
	rentalIncomeCurrency: string;
	serviceCharge: number;
	serviceChargeCurrency: string;
	situation: string;
	size: number;
	spExchangedDate: string;
	targetCompletionDate: string;
	tenure: number;
	yearBuild: string;
}

export interface IValuationDetail {
	mortgagePropertyDetailId: string;
	marketRent: number;
	marketRentCurrency: string;
	surveyorName: string;
	valuationDate: string;
	valuationValue: number;
	valuationValueCurrency: string;
}

export interface IBorrowerGuarantorBG {
	mortgagePropertyDetailId: string;
	employment: string;
	nationality: string;
	occupation: string;
	occupationOther: string;
	relationshipWithBorrower: string;
	type: BORROWER_GUARANTOR_TYPE;
}

export interface IFinancialBackground {
	mortgagePropertyDetailId: string;
	bankLoanApproval: boolean;
	esgCompliance: boolean;
	grossAssets: number;
	grossLiabilities: number;
	totalExpnses: number;
	totalIncome: number;
}

export interface ICreditHistory {
	anyKindOfLoanDefault: boolean;
	criminalOffenseExperiences: boolean;
	debtPenalties: boolean;
}

export interface IMortgageDealReports {
	belsCertificate?: [IDocument];
	contractNote?: [IDocument];
	epcReport?: [IDocument];
	legalTitleReport?: [IDocument];
	surveyorValuationReport?: [IDocument];
}

export interface IPropertyCompanyManagement {
	companyName?: string;
	addressLine?: string;
	street?: string;
	country?: string;
	district?: string;
	zipCode?: string;
	contactPerson?: string;
	contactCountryCode?: string;
	contactPhoneNumber?: string;
	emailAddress?: string;
}

export interface IReferral {
	companyNameOrIndividualName?: string;
	address?: string;
}
export interface IMortgageDetailsForm {
	id?: string;
	mortgageNumber?: string;
	loanDetails?: ILoanDetails;
	securityDetails?: ISecurityDetails;
	solicitorDetails?: ISolicitorDetails;
	propertyCompanyManagement?: IPropertyCompanyManagement;
	thirdPartyReferral?: IReferral[];
	mortgageGuarantors?: IGuarantor[];
	supportingDocuments?: IMortgageSupportingDoc;
	isCorporateRequest?: boolean;
	doYouHaveAReferral?: string;
}

export interface IReferralList {
	referralList?: IReferral[];
}

export interface IMortgageDetailsFormRequest {
	loanDetails: ILoanDetails;
	securityDetails: ISecurityDetails;
	solicitorDetails?: ISolicitorDetails;
	propertyCompanyManagement?: IPropertyCompanyManagement;
	thirdPartyReferral?: IReferralList;
	isCorporateRequest?: boolean;
	doYouHaveAReferral?: string;
}

export interface IMortgageInvestmentData {
	id?: string;
	mortgageApplicationId: string;
	mortgageNumber?: string;
	borrowerGuarantorBackgrounds?: IBorrowerGuarantorBG[];
	creditHistory?: ICreditHistory;
	media?: IMortgageDealMedia;
	reports?: IMortgageDealReports;
	securityValueFromSurveyor?: number;
	securityValueFromSurveyorCurrency?: string;
	valuationDetail?: IValuationDetail;
	propertyDetailAddress?: IPropertyDetailAddress;
	securedPropertyDetail?: ISecuredPropertyDetail;
	environmentalImpact?: IEnvironmentImpact;
	financialBackground?: IFinancialBackground;
	loanProposals?: ILoanProposal[];
	isFavorite: boolean;
	biddingLoanProposals: IFunderLoanProposalItem[];
}

export interface IFunderLoanProposalItem {
	biddingId: string;
	loanProposal: ILoanProposal;
	status: LoanProposalBiddingStatus;
}

export interface IEnvironmentImpact {
	id: string;
	mortgagePropertyDetailId: string;
	showEnv: boolean;
	epcRating: string;
	validUntilDate: Date;
	co2Saving: string;
	tonnesOfAhpCo2: number;
	tonnesOfPpCo2: number;
	belsRating: number;
	energySaving: string;
	energySavingPercentage: number;
}
